export class CustomerSearchRequest {
  customerIds?: number[];
  reportType?: string;
  customerId?: number;
  parentCustomerId?: number;
  cardNumber?: string;
  customerName?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  siteName?: string;
  buildingName?: string;
  doorNum?: string;
  addressDescription?: string;
  districtName?: string;
  storeIds?: number[];
  customerTypeIds?: number[];
  communityIds?: number[];
  minDiscount?: number;
  maxDiscount?: number;
  isForeign?: boolean | null;
  isBilling?: boolean | null;
  hasCardNumber?: boolean | null;
  billingProfileId?: string;
  showBalance?: boolean;
  notes?: string;
  billingName?: string;
  taxId?: string;
  taxOffice?: string;
  mobilePhoneNumbers?: string[];
  customerSourceIds?: number[];
  excludePhoneNumbers?: string[];
}
